import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import { numberToCurrency, sleep } from 'src/smoothr-web-app-core/utils/utils';
import { addToBasket, removeBasket } from '../../shared';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-recomendation-article-modal',
	templateUrl: './recomendation-article-modal.component.html',
	styleUrls: ['./recomendation-article-modal.component.scss'],
	standalone: false,
})
export class RecomendationArticleModalComponent implements OnInit {
	public articlesList: Article[] = [];
	public orderObservable = this.repositoryService.observableOrder;
	numberToCurrency = numberToCurrency;
	public selectedArticles: { article: Article; quantity: number }[] = [];
	public slidesPerView = 2.2;

	constructor(
		private modalCtrl: ModalController,
		private repositoryService: RepositoryService,
		private cdr: ChangeDetectorRef
	) {}

	static async show(
		modalCtrl: ModalController,
		articlesList: Article[]
	): Promise<{
		data: { article: Article; quantity: number }[];
	}> {
		const modal = await modalCtrl.create({
			component: RecomendationArticleModalComponent,
			cssClass: ['auto-height', 'recommendation-dialog'],
			componentProps: {
				articlesList,
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		return (await modal.onDidDismiss()).data;
	}

	ngOnInit() {
		// Adjust slides per view based on screen size
		this.updateSlidesPerView();
		window.addEventListener('resize', () => this.updateSlidesPerView());
	}

	trackBy(index: number, article: Article) {
		return article._id;
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	addArticlesToBasket() {
		this.modalCtrl.dismiss({
			data: this.selectedArticles,
		});
	}

	addToBasketModal(article: Article) {
		console.log(`addToBasketModal(article: ${article})`);
		addToBasket(this.modalCtrl, this.repositoryService, article, null, true, false);
	}

	removeFromBasketModal(article: Article) {
		console.log(`removeFromBasketModal(article: ${article})`);
		removeBasket(this.repositoryService, article);
	}

	private updateSlidesPerView() {
		if (window.innerWidth < 576) {
			this.slidesPerView = 1.5;
		} else if (window.innerWidth < 768) {
			this.slidesPerView = 2.2;
		} else if (window.innerWidth < 992) {
			this.slidesPerView = 2.5;
		} else {
			this.slidesPerView = 2.8;
		}
	}
}
